<div class="main-div">
    <div class="tile1">
        <mat-card *ngIf="!isEdit1">
            <button mat-icon-button class="edit" (click)="doEdit1()"><mat-icon>edit</mat-icon></button>
            <button mat-icon-button class="edit" (click)="mapPopUp()"><mat-icon>map</mat-icon></button>
            <h2>Hole 1: General information</h2>
            <p *ngIf="!mapComplete">Geofence: <a class="error">Not Complete</a></p>
            <p *ngIf="mapComplete">Geofence: <a class="complete">Complete</a></p>
            <p>Description: {{generalDescription}}</p>
            <p>Tips: {{generalTips}}</p>
        </mat-card>
        <mat-card *ngIf="isEdit1">
            <button mat-icon-button class="edit" (click)="cancelEdit1()"><mat-icon>cancel</mat-icon></button>
            <button mat-icon-button class="edit" (click)="saveGeneral()"><mat-icon>save</mat-icon></button>
            <h2>Edit General information</h2>
            <form [formGroup]="tile1Form">
                <mat-form-field class="editForm">
                    <mat-label>Description</mat-label>
                    <textarea rows="2" matInput placeholder={{generalDescription}} id="generalDescription" name="generalDescription" [(ngModel)]="generalDescription" formControlName="generalDescription" type="textarea"></textarea>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Tips</mat-label>
                    <textarea rows="2" matInput placeholder={{generalTips}} id="generalTips" name="generalTips" [(ngModel)]="generalTips" formControlName="generalTips" type="textarea"></textarea>
                </mat-form-field>
            </form>
        </mat-card>
    </div>
    <div class="tile2">
        <mat-card *ngIf="!isEdit2">
            <button mat-icon-button class="edit" (click)="doEdit2()"><mat-icon>edit</mat-icon></button>
            <h2>Blue Square</h2>
            <p>Description: {{blueDescription}}</p>
            <p>Par: {{bluePar}}</p>
            <p>Tips: {{blueTips}}</p>
            <p>Yards: {{blueYards}}</p>
        </mat-card>
        <mat-card *ngIf="isEdit2">
            <button mat-icon-button class="edit" (click)="cancelEdit2()"><mat-icon>cancel</mat-icon></button>
            <button mat-icon-button class="edit" (click)="saveBlue()"><mat-icon>save</mat-icon></button>
            <h2>Edit Blue Square information</h2>
            <form [formGroup]="tile2Form">
                <mat-form-field class="editForm">
                    <mat-label>Description</mat-label>
                    <textarea rows="2" matInput placeholder={{blueDescription}} id="blueDescription" name="blueDescription" [(ngModel)]="blueDescription" formControlName="blueDescription" type="textarea"></textarea>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Par</mat-label>
                    <input matInput placeholder={{bluePar}} id="bluePar" name="bluePar" [(ngModel)]="bluePar" formControlName="bluePar" type="number" min="0">
                    <mat-error>
                        Number must be positive
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Tips</mat-label>
                    <textarea rows="2" matInput placeholder={{blueTips}} id="blueTips" name="blueTips" [(ngModel)]="blueTips" formControlName="blueTips" type="textarea"></textarea>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Yards</mat-label>
                    <input matInput placeholder={{blueYards}} id="blueYards" name="blueYards" [(ngModel)]="blueYards" formControlName="blueYards" type="number" min="0">
                    <mat-error>
                        Number must be positive
                    </mat-error>
                </mat-form-field>
            </form>
        </mat-card>
    </div>
    <div class="divider"></div>
    <div class="tile3">
        <mat-card *ngIf="!isEdit3">
            <button mat-icon-button class="edit" (click)="doEdit3()"><mat-icon>edit</mat-icon></button>
            <h2>Red Circle</h2>
            <p>Description: {{redDescription}}</p>
            <p>Par: {{redPar}}</p>
            <p>Tips: {{redTips}}</p>
            <p>Yards: {{redYards}}</p>
        </mat-card>
        <mat-card *ngIf="isEdit3">
            <button mat-icon-button class="edit" (click)="cancelEdit3()"><mat-icon>cancel</mat-icon></button>
            <button mat-icon-button class="edit" class="edit" (click)="saveRed()"><mat-icon>save</mat-icon></button>
            <h2>Edit Red Circle information</h2>
            <form [formGroup]="tile3Form">
                <mat-form-field class="editForm">
                    <mat-label>Description</mat-label>
                    <textarea rows="2" matInput placeholder={{redDescription}} id="redDescription" name="redDescription" [(ngModel)]="redDescription" formControlName="redDescription" type="textarea"></textarea>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Par</mat-label>
                    <input matInput placeholder={{redPar}} id="redPar" name="redPar" [(ngModel)]="redPar" formControlName="redPar" type="number" min="0">
                    <mat-error>
                        Number must be positive
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Tips</mat-label>
                    <textarea rows="2" matInput placeholder={{redTips}} id="redTips" name="redTips" [(ngModel)]="redTips" formControlName="redTips" type="textarea"></textarea>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Yards</mat-label>
                    <input matInput placeholder={{redYards}} id="redYards" name="redYards" [(ngModel)]="redYards" formControlName="redYards" type="number" min="0">
                    <mat-error>
                        Number must be positive
                    </mat-error>
                </mat-form-field>
            </form>
        </mat-card>
    </div>
    <div class="tile4">
        <mat-card *ngIf="!isEdit4">
            <button mat-icon-button class="edit" (click)="doEdit4()"><mat-icon>edit</mat-icon></button>
            <h2>Pink Diamond</h2>
            <p>Description: {{pinkDescription}}</p>
            <p>Par: {{pinkPar}}</p>
            <p>Tips: {{pinkTips}}</p>
            <p>Yards: {{pinkYards}}</p>
        </mat-card>
        <mat-card *ngIf="isEdit4">
            <button mat-icon-button class="edit" (click)="cancelEdit4()"><mat-icon>cancel</mat-icon></button>
            <button mat-icon-button class="edit" (click)="savePink()"><mat-icon>save</mat-icon></button>
            <h2>Edit Pink Diamond information</h2>
            <form [formGroup]="tile4Form">
                <mat-form-field class="editForm">
                    <mat-label>Description</mat-label>
                    <textarea rows="2" matInput placeholder={{pinkDescription}} id="pinkDescription" name="pinkDescription" [(ngModel)]="pinkDescription" formControlName="pinkDescription" type="textarea"></textarea>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Par</mat-label>
                    <input matInput placeholder={{pinkPar}} id="pinkPar" name="pinkPar" [(ngModel)]="pinkPar" formControlName="pinkPar" type="number" min="0">
                    <mat-error>
                        Number must be positive
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Tips</mat-label>
                    <textarea rows="2" matInput placeholder={{pinkTips}} id="pinkTips" name="pinkTips" [(ngModel)]="pinkTips" formControlName="pinkTips" type="textarea"></textarea>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Yards</mat-label>
                    <input matInput placeholder={{pinkYards}} id="pinkYards" name="pinkYards" [(ngModel)]="pinkYards" formControlName="pinkYards" type="number" min="0">
                    <mat-error>
                        Number must be positive
                    </mat-error>
                </mat-form-field>
            </form>
        </mat-card>
    </div>
    <div class="divider"></div>
    <div class="tile5">
        <mat-card *ngIf="!isEdit5">
            <button mat-icon-button class="edit" (click)="doEdit5()"><mat-icon>edit</mat-icon></button>
            <h2>Yellow Triangle</h2>
            <p>Description: {{yellowDescription}}</p>
            <p>Par: {{yellowPar}}</p>
            <p>Tips: {{yellowTips}}</p>
            <p>Yards: {{yellowYards}}</p>
        </mat-card>
        <mat-card *ngIf="isEdit5">
            <button mat-icon-button class="edit" (click)="cancelEdit5()"><mat-icon>cancel</mat-icon></button>
            <button mat-icon-button class="edit" (click)="saveYellow()"><mat-icon>save</mat-icon></button>
            <h2>Edit Yellow Triangle information</h2>
            <form [formGroup]="tile5Form">
                <mat-form-field class="editForm">
                    <mat-label>Description</mat-label>
                    <textarea rows="2" matInput placeholder={{yellowDescription}} id="yellowDescription" name="yellowDescription" [(ngModel)]="yellowDescription" formControlName="yellowDescription" type="textarea"></textarea>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Par</mat-label>
                    <input matInput placeholder={{yellowPar}} id="yellowPar" name="yellowPar" [(ngModel)]="yellowPar" formControlName="yellowPar" type="number" min="0">
                    <mat-error>
                        Number must be positive
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Tips</mat-label>
                    <textarea rows="2" matInput placeholder={{yellowTips}} id="yellowTips" name="yellowTips" [(ngModel)]="yellowTips" formControlName="yellowTips" type="textarea"></textarea>
                </mat-form-field>
                <mat-form-field class="editForm">
                    <mat-label>Yards</mat-label>
                    <input matInput placeholder={{yellowYards}} id="yellowYards" name="yellowYards" [(ngModel)]="yellowYards" formControlName="yellowYards" type="number" min="0">
                    <mat-error>
                        Number must be positive
                    </mat-error>
                </mat-form-field>
            </form>
        </mat-card>
    </div>
</div>
